<mat-nav-list>
  @if (recycledContent) {
    @for (component of recycledContent; track component; let i = $index) {
      <a
        mat-list-item
        (click)="goToProductOverview($event, component.id)"
        (keydown)="onKeydown($event, i)"
        [attr.tabindex]="i === 0 ? 0 : -1"
      >
        <!-- Component Name -->
        <span matListItemTitle class="component-name">{{
          component.name
        }}</span>

        <!-- Package information -->
        @if (component.packageType) {
          <span matListItemLine class="package-section">
            <span class="bold">{{ component.packageType }}</span>
            {{ translationService.getPackagingText() }}
          </span>
        }

        <!-- Recycled Content Information -->
        @if (component.recycledContentPercentage) {
          <span matListItemLine class="recycled-content-section">
            <span class="bold">{{ component.recycledContentPercentage }}%</span>
            {{ translationService.getRecycledContentText() }}
          </span>
        } @else {
          <span matListItemLine>{{
            translationService.getRecycledContentPercentageNaText()
          }}</span>
        }
      </a>
      <mat-divider></mat-divider>
    } @empty {
      <span>{{ translationService.getNoRecycledContentAvailableText() }}</span>
    }
  }
</mat-nav-list>
